<div class="pages" id="pages">
  <div class="container">
    <div class="pages__wrapper row">
      @for ( card of allArticles() | paginate : { itemsPerPage:
      articlesPerPage(), currentPage: currentPage() }; track card; let i =
      $index ) {
      <div class="col-12 col-md-6">
        <app-news-card [config]="card"></app-news-card>
      </div>
      }
    </div>
    <div class="pages__content row">
      <pagination-controls
        class="pages__content-controls"
        (pageChange)="currentPage.set($event)"
      ></pagination-controls>
    </div>
  </div>
</div>
